<script setup>
import { computed, ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import CategoryModal from "./CategoryModal.vue"
import CategoryEditModal from "./CategoryEditModal.vue"
import CategoriesTable from "./CategoriesTable.vue"


const title = "مدیریت دسته بندی ها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت دسته بندی ها",
    active: true,
  },
])

const DEFAULT_CATEGORY = {
  id: "",
  parent_id: "",
  category_name: "",
  category_slug: "",
  category_image: "",
  is_in_menu: "",
}

const allCategories = computed(() => store.state.allCategories)

const categoryModel = ref({ ...DEFAULT_CATEGORY })
const showCategoryModal = ref(false)
const showCategoryEditModal = ref(false)

const showAddNewModal = () => {
  showCategoryModal.value = true
}

const showEditModal = () => {
  showCategoryEditModal.value = true
}

function editCategory(cat) {
  store.dispatch("getCategory", cat.id).then(({ data }) => {
    categoryModel.value = data.data
    showEditModal()
  })
}

const onModalClose = () => {
  categoryModel.value = { ...DEFAULT_CATEGORY }
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="categoryList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست دسته بندی ها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن دسته
                    بندی جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- categories table  -->

          <CategoriesTable @clickEdit="editCategory" />

          <!-- add and edit category modal  -->

          <CategoryModal
            v-model="showCategoryModal"
            :category="categoryModel"
            :allCategories="allCategories"
            @close="onModalClose"
          />

          <CategoryEditModal
            v-model="showCategoryEditModal"
            :category="categoryModel"
            :allCategories="allCategories"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
